import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { baseTaskComponent } from './baseTask.component';
import { DossierHeaderModule } from '../../dossiers/components/dossierHeader.module';

import { MessageTaskModule } from '../messageTask/messageTask.module';

import { BasicDocumentModule } from '../../documents/basicDocument/basicDocument.module';

import { TranslateModule } from '@ngx-translate/core';
import { EmptyModule } from '../../components/empty.module';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { TenderEventModule } from '../../dossiers/tenderEvent/tenderEvent.module';
import { PublicationInfoModule } from '../../dossiers/publicationInfo/publicationInfo.module';
import { TenderViewModule } from '../../dossiers/tenderView/tenderView.module';
import { AwardModule } from '../../dossiers/awards/awards.module';
import { ETenderingDefinitionModule } from '../../dossiers/eTenderingDefinition/eTenderingDefinition.module';
import { DirectivesModule } from '../../directives/directives.module';
import { ReceiptModule } from '../receipt/receipt.module';
import { ProcurementProjectLotStateInfoModule } from '../procurementProjectLotStateInfo/procurementProjectLotStateInfo.module';
import { EndorsementModule } from '../endorsement/endorsement.module';
import { CertificationModule } from '../certification/certification.module';
import { SettlementModule } from '../settlement/settlement.module';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { GuaranteeRefundModule } from '../guaranteeRefund/guaranteeRefund.module';
import { AssignManagerModule } from '../assignManager/assignManager.module';
import { TaskAssignmentModule } from '../taskAssignment/taskAssignment.module';
import { TenderClassificationModule } from '../tenderClassification/tenderClassification.module';
import { ConfirmationService } from 'primeng-lts/api';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TaskActionsProcessModule } from '../task.actions.process.module';
import { FinanceProjectModule } from '../../bsm/financeproject.module';
import { IncomeModule } from '../../bsm/income.module';
import { CommunicationsModule } from '../../dossiers/communications/communications.module';
import { CodeInclusionModule } from '../codeinclusion/codeInclusion.module';
import { DebtInquiriesModule } from '../../integration/debtinquiries.module';
import { ProceduresModule } from '../../dossiers/procedures/procedures.module';
import { ChangePhaseTaskModule } from '../changePhaseTask/changePhaseTask.module';
import { RequestedMaterialModule } from '../../dossiers/requestedMaterial/requestedMaterial.module';
import { CertificationPaymentComponent } from '../../dipbad/certificationPayment/certificationPayment.component';
import { CertificationPaymentModule } from '../../dipbad/certificationPayment/certificationPayment.module';



@NgModule({
  declarations: [baseTaskComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    RouterModule,
    DossierHeaderModule,
    MessageTaskModule,
    BasicDocumentModule,
    TenderEventModule,
    AwardModule,
    PublicationInfoModule,
    TenderViewModule,
    TenderClassificationModule,
    EmptyModule,
    WaitLoadingModule,
    PanelModule,
    ConfirmDialogModule,
    ETenderingDefinitionModule,
    DirectivesModule,
    ReceiptModule,
    ProcurementProjectLotStateInfoModule,
    EndorsementModule,
    CertificationModule,
    SettlementModule,
    SubHeaderModule,
    ScrollPanelModule,
    GuaranteeRefundModule,
    AssignManagerModule,
    TaskAssignmentModule,
    TaskActionsProcessModule,
    FinanceProjectModule,
    IncomeModule,
    CommunicationsModule,
    CodeInclusionModule,
    DebtInquiriesModule,
    ChangePhaseTaskModule,
    ProceduresModule,
    RequestedMaterialModule,
    CertificationPaymentModule
  ],
  exports: [DirectivesModule],
  providers: [ConfirmationService, DialogService]
})
export class BaseTaskModule { }
